import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import { Card, CardContent } from "@babackapp/ui/components/card";
import { TagIcon } from "lucide-react";
import AssignedMembers from "@/pages/(app)/returns/view/components/assigned-members/assigned-members";
import BillingAddress from "@/pages/(app)/returns/view/components/return-sidebar/billing-address";
import CustomerInfo from "@/pages/(app)/returns/view/components/return-sidebar/customer-info";
import RelatedReturns from "@/pages/(app)/returns/view/components/return-sidebar/related-returns";
import ShippingAddress from "@/pages/(app)/returns/view/components/return-sidebar/shipping-address";
import Transport from "@/pages/(app)/returns/view/components/return-sidebar/transport";

type ReturnSidebarProps = {
	returnRequest: ReturnRequestDto;
};

export default function ReturnSidebar({ returnRequest }: ReturnSidebarProps) {
	const t = useTranslation();

	return (
		<div className="relative h-full xl:w-[280px] w-full">
			<Card className={"w-full flex flex-col bg-background sticky top-8"}>
				<CardContent className="py-8">
					<div className={"flex-1 overflow-y-auto"}>
						<div className="grid grid-cols-2 xl:grid-cols-1 gap-8">
							<Transport returnRequest={returnRequest} />
							{returnRequest.orderTags && returnRequest.orderTags.length > 0 && (
								<div>
									<div className="flex items-center gap-2 mb-3">
										<TagIcon className="size-3 text-gray-500" />
										<h2 className="text-sm font-medium text-gray-500">
											{t("returnDetail.orderTags.label")}
										</h2>
									</div>
									<div className="flex flex-wrap gap-2">
										{returnRequest.orderTags.map((tag) => (
											<Badge key={tag} variant="secondary" size="xs">
												{tag}
											</Badge>
										))}
									</div>
								</div>
							)}

							<RelatedReturns
								returnRequestId={returnRequest.id}
								shopId={returnRequest.shopId}
							/>
							<CustomerInfo returnRequest={returnRequest} />
							<ShippingAddress returnRequest={returnRequest} />
							<BillingAddress returnRequest={returnRequest} />
							<div>
								<div className="space-y-5">
									<h2 className="text-sm font-medium text-gray-500">
										{t("misc.users")}
									</h2>
								</div>
								<AssignedMembers returnRequest={returnRequest} />
							</div>
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	);
}
